// extracted by mini-css-extract-plugin
export var BackgroundImage = "Cover-module--BackgroundImage--d7f49";
export var Buttons = "Cover-module--Buttons--5d546";
export var Content = "Cover-module--Content--4dcc3";
export var Cover = "Cover-module--Cover--01746";
export var Description = "Cover-module--Description--d271b";
export var Overlay = "Cover-module--Overlay--01e48";